import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

let maskSceneC: any = null,
    titleSceneC: any = null;
export default function D() {
    const { useLang, useEffect, useState } = useGlobal();
    const { t } = useLang('delta_pro_ultra.launch.detail');
    const [textEnter, setTextEnter] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resizeAni = () => {
                if (maskSceneC) {
                    AniContainer.removeScene(maskSceneC);
                    maskSceneC = null;
                }
                if (titleSceneC) {
                    AniContainer.removeScene(titleSceneC);
                    titleSceneC = null;
                }
                const pageHeight = window.innerHeight;
                const clientH = (pageHeight || 0) * 0.2;

                const startH = window.innerWidth <= 1024 ? -(pageHeight * 0.5) : Math.min(clientH, 150);
                titleSceneC = AniContainer.create({
                    triggerElement: '.dpu-detail-D .sticky-box',
                    triggerHook: 0,
                    offset: startH,
                    duration: window.innerHeight * 2,
                    onEnter: () => {
                        setTextEnter(true);
                    },
                });
            };
            resizeAni();
            return () => {
                if (maskSceneC) {
                    AniContainer.removeScene(maskSceneC);
                    maskSceneC = null;
                }
                if (titleSceneC) {
                    AniContainer.removeScene(titleSceneC);
                    titleSceneC = null;
                }
            };
        }
    }, []);

    return (
        <section className={`dpu-detail-D dpu-detail-section ${css['dpu-detail-D']}`}>
            <div className={`sticky-box ${textEnter ? 'enter' : ''}`}>
                <div className="img-box">
                    <EFPicture
                        src={`/responsive/picture/delta-pro-ultra/launch/4.jpg`}
                        srcPad={`/responsive/picture/delta-pro-ultra/launch/4.jpg`}
                        srcMobile={`/responsive/picture/delta-pro-ultra/launch/4.jpg`}
                        alt={t('secD_title')}
                    />
                    <div className="mask"></div>
                    <div className="title-box">
                        <h2 className="title">{t('secD_title')}</h2>
                        <p className="desc">{t('secD_desc')}</p>
                    </div>
                </div>
            </div>
        </section>
    );
}
